import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "grid-content" }
const _hoisted_3 = { class: "grid-content" }
const _hoisted_4 = { class: "data-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right-data" }
const _hoisted_7 = { class: "data-num" }
const _hoisted_8 = { class: "data-title" }
const _hoisted_9 = { class: "rank-data" }

import { getCurrentInstance, ref, onMounted, reactive, computed } from 'vue'
import { useStore } from '@/store/index'
import * as echarts from 'echarts'
import { Top, Bottom } from '@element-plus/icons-vue'
import { getDelayTime, dateFormat } from '@/utils/index'
import { BrandCat } from '@/enums/brand'
import { getBrandListApi } from '@/apis/brand'
import { BrandM } from '@/models/brand'
import RankTable from '@/components/RankTable.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelData',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const hasShop = store.state.user.userInfo
const today = new Date()
const current = dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`);
const filters = reactive({
    start_date: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-1`), //开始日期
    end_date: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`), //结束日期
    cat_id:'',
    province_id:'',
    city_id:'',   
    brand_id:'',
    type:3,
})
const brandProps = {
    value: 'id',
    label: 'name'
}
const detailsData = reactive({
    onSaleGoods:'', //在售商品
    salesAmount:'', //销售额
    waitSendOrder:'', //待发货订单
    orderNum:'', //订单数
    unitPrice: '', //客单价
    cakeOrderNum:'', //蛋糕订单数
    snackOrderNum: '', //零食订单数
    flowerOrderNum: '', //鲜花订单数
    couponOrderNum: '', //电子券订单数
})
const dataRows = computed(() => [
    {
        dataRow: [
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014142301_849.png", number: detailsData.waitSendOrder, title: "待发货订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014142126_224.png", number: detailsData.salesAmount, title: "销售额", bgColor: "#fff8f7", iconBgColor: "#ffebe8" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014142514_3.png", number: detailsData.unitPrice,title: "客单价", bgColor: "#f7fdfa", iconBgColor: "#dcf8ec" },
        ]
    },
    {
        dataRow: [
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014145102_392.png", number: detailsData.orderNum, title: "订单数量", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014145318_168.png", number: detailsData.cakeOrderNum, title: "蛋糕订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014145327_535.png", number: detailsData.snackOrderNum, title: "零食订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014145620_932.png", number: detailsData.flowerOrderNum, title: "鲜花订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },
            { icon: "https://image-oss.dangaoss.cn/common/common_20241014145708_778.png", number: detailsData.couponOrderNum, title: "电子券订单", bgColor: "#fbf9ff", iconBgColor: "#eee8ff" },

        ]
    },
])
const state = reactive({
    options:[],
    product_shelf_rate: 0,//运营下架-商品溢价占比
    discount_shelf: 0,//运营下架-折扣不合格 
    discount_shelf_rate: 0,//运营下架-折扣不合格占比 
    info_shelf: [],//运营下架-信息有误
    info_shelf_rate: [],//运营下架-信息有误占比
    quality_shelf: [],//运营下架-质量问题
    quality_shelf_rate: [],//运营下架-质量问题占比
    taste_shelf: [],//运营下架-口感不佳
    taste_shelf_rate: [],//运营下架-口感不佳占比
    other_shelf: [],//运营下架-其他
    other_shelf_rate: [],//运营下架-其他占比
    cakeBrandData: [
    // 蛋糕品牌排行榜数据
    ],
    snackBrandData: [
    // 零食品牌排行榜
    ],
    couponBrandData: [
    // 电子券品牌排行榜
    ]
})
const getList = () => {
    proxy.$http.get('/data/operate_basics_data', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(detailsData, data)
    })
    proxy.$http.get('/data/brand_ranking', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        state.cakeBrandData = data.cake
        state.snackBrandData = data.Second_brand
        state.couponBrandData = data.coupon
    })
}
getList()
const search = () => {
    if (filters.start_date && filters.end_date) {
        if (filters.end_date >= filters.start_date) {
            getList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}
//@ts-ignore
const disabledStartDate = (date) => { // 返回开始不可用日期
    //所选时间小于等于当前日期
    var start = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    return start > current
}
//@ts-ignore
const disabledEndDate = (date) => { // 返回结束不可用日期
    //@ts-ignore
    var start = new Date(filters.start_date).getTime()
    //所选时间小于等于当前日期
    //@ts-ignore
    var end = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    //所选时间小于等于当前日期或小于开始日期
    return end > current || end < start
}
const onBrandChange = (val) => {
    filters.brand_id = val
}
// 获取城市列表
const cityList = ref<any[]>([])
const getCityList = () => {
    proxy.$http.get(`/cake_api/getCityListByBrandId?brand_id=${filters.brand_id}`).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        cityList.value = data
        // if (data.length > 0) {
        //     filters.city_id = data[0].options[0].id
        // }
    })
}
getCityList()
const brandList = ref<BrandM[]>([])
// 获取品牌列表
const getBrandListFn = () =>{
    const{ city_id,cat_id } = filters
    proxy.$http.get('/admin/shop_product/getBrandList', {city_id: city_id, cat_id: cat_id}).then((res:any) => {
        // const { code, data, msg } = res
        if (res.code != 200) { return proxy.$message({ type: 'error', message: res.msg }) }
        brandList.value = res.data                  
    })
}
const handleCatChange = (value) => {
    filters.brand_id = ''
    getBrandListFn() 
    // getList()
}
getBrandListFn()
const maxWidth = ref('auto');

const calculateMaxWidth = () => {
  let maxItemWidth = 0;

  const items = document.querySelectorAll('.data-item');
  items.forEach(item => {
    const rect = item.getBoundingClientRect();
    if (rect.width > maxItemWidth) {
      maxItemWidth = rect.width;
    }
  });

  maxWidth.value = `${maxItemWidth}px`;
};

onMounted(() => {
  calculateMaxWidth();
  window.addEventListener('resize', calculateMaxWidth);
});

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, {
      offset: 0,
      style: {"background-color":"#fff","height":"130px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"margin-top":"10px","padding":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  class: "filter-item",
                  modelValue: filters.brand_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_id) = $event)),
                  placeholder: "请选择品牌",
                  filterable: "",
                  clearable: "",
                  style: {"width":"200px"},
                  props: brandProps,
                  options: brandList.value,
                  onChange: onBrandChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: filters.cat_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.cat_id) = $event)),
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择类型",
                  class: "filter-item",
                  style: {"width":"150px"},
                  onChange: handleCatChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "蛋糕",
                      value: _unref(BrandCat)['蛋糕']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "零食",
                      value: _unref(BrandCat)['零食']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "鲜花",
                      value: _unref(BrandCat)['鲜花']
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "电子券",
                      value: _unref(BrandCat)['电子券']
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: filters.city_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.city_id) = $event)),
                  filterable: "",
                  placeholder: "请选择城市",
                  autocomplete: "no",
                  style: {"width":"200px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        key: group.lable,
                        label: group.lable
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.lable,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { style: {"padding":"0px 20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text" }, "选择日期：", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.start_date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_date) = $event)),
                    "disabled-date": disabledStartDate,
                    placeholder: "开始日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text" }, " - ", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.end_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.end_date) = $event)),
                    "disabled-date": disabledEndDate,
                    placeholder: "结束日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    class: "filter-btn",
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (search()))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataRows.value, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "data-row",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.dataRow, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "data-item",
              key: itemIndex,
              style: _normalizeStyle({ backgroundColor: item.bgColor,width: maxWidth.value })
            }, [
              _createElementVNode("div", {
                class: "left-icon",
                style: _normalizeStyle({ backgroundColor: item.iconBgColor })
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_5)
              ], 4),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.number), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
              ])
            ], 4))
          }), 128))
        ]))
      }), 128))
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "model-title" }, [
      _createElementVNode("div", { class: "shelf-data-title" }, "排行榜（以时间维度统计）")
    ], -1)),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(RankTable, {
        title: "蛋糕品牌排行榜",
        data: state.cakeBrandData,
        columns: [
                { prop: 'brand_id', label: '品牌ID' },
                { prop: 'brand_name', label: '品牌名称' },
            ]
      }, null, 8, ["data"]),
      _createVNode(RankTable, {
        title: "零食品牌排行榜",
        data: state.snackBrandData,
        columns: [
                { prop: 'secondary_brand_id', label: '品牌ID' },
                { prop: 'secondary_brand_name', label: '品牌名称' },
            ]
      }, null, 8, ["data"]),
      _createVNode(RankTable, {
        title: "电子券品牌排行榜",
        data: state.couponBrandData,
        columns: [
                { prop: 'brand_id', label: '品牌ID' },
                { prop: 'brand_name', label: '品牌名称' },
            ]
      }, null, 8, ["data"])
    ])
  ]))
}
}

})